/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { FranchiseReportFilterDto, FranchiseReportFilterListDto } from '@gh/builder-shared-data';
import { cast } from '@gh/core-util';

import { map, omit, split, toNumber } from 'lodash';

export type FranchiseReportFilterList = FranchiseReportFilterListDto & {
  monthCode: string;
  historySettings: FranchiseReportFilter[];
};

export type FranchiseReportFilter = FranchiseReportFilterDto & {
  monthCode: string;
};

export type FranchiseReportFilterDate = {
  forMonth: number;
  forYear: number;
};

export type FranchiseReportMonthSelectOption = {
  monthCode: string;
  name: string;
};

export const franchiseReportFilterListFromDto =
  (reportFilterList: FranchiseReportFilterListDto): FranchiseReportFilterList => ({
    ...cast<FranchiseReportFilter>(omit(reportFilterList, ['historySettings'])),
    monthCode: composeMonthCode(cast<FranchiseReportFilter>(omit(reportFilterList, ['historySettings']))),
    historySettings: map(reportFilterList.historySettings, (report: FranchiseReportFilter) => ({
      ...report,
      monthCode: composeMonthCode(report),
    })),
  });

export const franchiseReportFilterListToDto =
  (reportFilterList: FranchiseReportFilterList): FranchiseReportFilterListDto => ({
    ...<FranchiseReportFilterDto>omit(reportFilterList, ['historySettings', 'monthCode']),
    historySettings: map(reportFilterList.historySettings, (report: FranchiseReportFilter) =>
      <FranchiseReportFilterDto>omit(report, ['monthCode'])),
  });

export function composeMonthCode({ forYear, forMonth }: FranchiseReportFilter): string {
  return `${forMonth}:${forYear}`;
}

export function decomposeMonthCode(monthCode: string): FranchiseReportFilterDate {
  const [forMonth, forYear] = split(monthCode, ':', 2);
  return {
    forMonth: toNumber(forMonth),
    forYear: toNumber(forYear),
  };
}
